import React, { useState } from 'react';
import { IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import ClaimInformation from 'containers/PreOpeningPage/ClaimInformation';
import ClaimCircumstances from 'containers/PreOpeningPage/ClaimCircumstances';
import ClaimDeclaration from 'containers/PreOpeningPage/ClaimDeclaration';
import VictimCard from 'containers/PreOpeningPage/VictimCard';
import UploadDocumentsBloc from 'containers/RecapPage/uploadDocumentsBloc';
import DialogFeeNote from 'components/DialogFeeNote';
import { filterFeeNotes } from 'containers/CourtManagerLegalProceedings/utils';
import { Listings } from 'containers/AppContainer/typings';
import {
  CLAIM_STATUS,
  EMPTY_CLAIM_TO_PREOPEN,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import DecisionComponent from 'containers/RecapManagerPage/DecisionComponent';
import Breadcrumbs from 'containers/RecapManagerPage/Breadcrumbs';
import { claimStatusLabel } from 'containers/RecapManagerPage/utils';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import OpposingPartyRecapContainer from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecapContainer';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import FraudeInformation from 'containers/PreOpeningPage/fraude';
import { isOpeningManager } from 'containers/AppContainer/utils';
import userPrivileges, {
  userHasPrivilege,
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerRecapPage/messages';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  EMPTY_SUPPORT_DOC,
  PV_DOC_ID,
} from 'containers/LawyerRecapPage/constants';
import {
  GlobalBloc,
  Container,
  StyledButton,
} from 'containers/RecapManagerPage/PendingOrRejectedRecapClaim/styles';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import LawyerClaimCircumstances from 'containers/LawyerRecapPage/LawyerClaimCircumstances';
import ProvisionIntervenantDialog from 'containers/RecapManagerPage/ProvisionIntervenantDialog';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import WarningCard from 'containers/common/Card/WarningCard';
import { useSelector } from 'react-redux';
import { formatBodyClaimToUpdate } from 'containers/RecapManagerPage/PendingOrRejectedRecapClaim/utils';
import { ClaimRecapType } from 'typings/claimTypes';
import Alert from '@material-ui/lab/Alert';
export interface PendingOrRejectedRecapClaimProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  claimId: number;
  requestClaimRecap: Function;
  match: { params: { claimId: number } };
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  setClaimRecap: Function;
  requestRejectClaim: Function;
  requestOpenClaim: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  requestOpenMixedClaim: Function;
  corporealLawyers: KeycloakUser[];
  openedClaim: any;
  requestUpdateVictimInfo?: Function;
  requestCreateVehicle?: Function;
  requestValidateVictim?: Function;
  requestValidateVehicle: Function;
  requestAddVictims?: Function;
  requestUpdateVehicleInfo: Function;
  requestUpdateClaim?: Function;
  resetUploadDocumentStore?: Function;
  uploadDocument?: Function;
  uploadedDocument: IUploadedDocument;
  setDocumentId?: Function;
  documentId: string;
  requestAddDocumentClaim?: Function;
  requestValidateProvisionIntervenant?: Function;
  requestUnlockClaim: Function;
  requestLockClaim: Function;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  foundClaims: any;
  requestAddClaimNumber: Function;
  feeNotes: any;
  loaders: any;
  requestGetFeeNotesByClaimId: Function;
  allFeeNote: any;
  feeNotesCount: any;
  linkToBeneficiaryCodes: any;
  requestAddInvoiceFeeNote: Function;
  makeDecisionFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  requestAllFeeNotes: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  dataClaimToUpdate: any;
  setDataClaimToUpdate: Function;
  setOpenFeeNoteDialog: Function;
  openFeeNoteDialog: any;
  requestGetReportsPolicy: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
  requestValidateCompletionClaimManager: Function;
}

export const PendingOrRejectedRecapClaim: React.FC<PendingOrRejectedRecapClaimProps> = (
  props,
): JSX.Element => {
  const [
    isProvisionIntervenantDialogOpen,
    setIsProvisionIntervenantDialogOpen,
  ] = useState<boolean>(false);

  const handleClose = () => {
    props.setOpenFeeNoteDialog(false);
  };
  const [page, setPage] = React.useState<number>(0);

  const getClaimStatus = () => {
    const claim = get(props.claimRecap, 'claim', {});
    const status = get(claim, 'status', '');
    return claimStatusLabel(status, props);
  };

  const getClaimNumber = () => {
    const claim = get(props.claimRecap, 'claim', {});
    return get(claim, 'claimNumber', '');
  };

  const successCallback = () => {
    toast.success(translate(messages.validationSuccessMessage, props));
  };

  const [updatedPVDocument, setUpdatedPVDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const deletePVDocument = (document: CorporealDocument) => {
    setUpdatedPVDocument({ ...EMPTY_SUPPORT_DOC });
  };

  const setDocument = (document: CorporealDocument) => {
    if (props.requestAddDocumentClaim)
      props.requestAddDocumentClaim({
        ...document,
        claimId: props.match.params.claimId,
        claimNumber: getClaimNumber(),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
      });
    if (props.resetUploadDocumentStore) props.resetUploadDocumentStore();
    props.requestClaimRecap(props.claimId);
  };

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );

  const setPVDocument = (document: CorporealDocument) => {
    if (props.documentId === PV_DOC_ID) {
      setUpdatedPVDocument(document);
      if (props.resetUploadDocumentStore) props.resetUploadDocumentStore();
    }
  };
  const provisionIntervenants =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'contractorFees', []);

  const riskId =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    )?.riskId;

  const [isSearchExecuted, setIsSearchExecuted] = useState(false);
  const handleClickUpdateClaim = () => {
    props.requestUpdateClaim &&
      props.requestUpdateClaim(
        formatBodyClaimToUpdate(
          props.dataClaimToUpdate,
          props.claimRecap,
          priorityReasonClaimId,
          props.listings,
          props.policyInfo,
          riskId,
          props.claimId,
          getClaimNumber(),
        ),
        props.claimId,
        successCallback,
      );
  };
  const [
    isProvisionalReferenceAlertOpenned,
    setIsProvisionalReferenceAlertOpenned,
  ] = useState(false);

  return (
    <>
      <GlobalBloc className="globalBloc">
        {featureService.hasFeature(FEATURES.COURT_CALENDAR) &&
          isProvisionalReferenceAlertOpenned && (
            <Alert
              severity="error"
              style={{ marginBottom: '16px' }}
              onClose={() => {
                setIsProvisionalReferenceAlertOpenned(false);
              }}
            >
              {translate(
                { ...messages.preOpeningPageProvisionalReferenceAlertError },
                props,
              )}
            </Alert>
          )}
        <Breadcrumbs
          claimStatus={getClaimStatus()}
          claimNumber={getClaimNumber()}
        />
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}

        {userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) && (
          <DecisionComponent
            listings={props.listings}
            requestSearchClaims={props.requestSearchClaims}
            claimId={props.match.params.claimId}
            claimRecap={props.claimRecap}
            requestRejectClaim={props.requestRejectClaim}
            requestOpenClaim={props.requestOpenClaim}
            requestAssigment={props.requestAssigment}
            policyInfo={props.policyInfo}
            requestCorporealLawyers={props.requestCorporealLawyers}
            corporealLawyers={props.corporealLawyers}
            requestOpenMixedClaim={props.requestOpenMixedClaim}
            openedClaim={props.openedClaim}
            dataClaimToUpdate={props.dataClaimToUpdate}
            setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
            isSearchExecuted={isSearchExecuted}
            setIsProvisionalReferenceAlertOpenned={
              setIsProvisionalReferenceAlertOpenned
            }
            requestValidateCompletionClaimManager={
              props.requestValidateCompletionClaimManager
            }
          />
        )}
        {featureService.hasFeature(FEATURES.FEE_NOTE) &&
          !isEmpty(props.feeNotes) && (
            <DialogFeeNote
              allFeeNote={props.allFeeNote}
              requestAllFeeNotes={props.requestAllFeeNotes}
              feeNotes={filterFeeNotes(props.feeNotes, false, {}, false)}
              feeNotesCount={props.feeNotesCount}
              requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
              requestCreateFeeNote={props.requestCreateFeeNote}
              requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
              keyclokToken={null}
              resetUploadDocumentStore={
                props.resetUploadDocumentStore
                  ? props.resetUploadDocumentStore
                  : () => {}
              }
              uploadDocument={
                props.uploadDocument ? props.uploadDocument : () => {}
              }
              uploadedDocument={props.uploadedDocument}
              setDocumentId={
                props.setDocumentId ? props.setDocumentId : () => {}
              }
              documentId={props.documentId}
              makeDecisionFeeNote={props.makeDecisionFeeNote}
              open={props.openFeeNoteDialog}
              handleClose={handleClose}
              showButtonAdd={false}
              title={translate(messages.FeeNoteTitle, props)}
              claimNumber={get(props.claimRecap, 'claim.claimNumber')}
              listings={props.listings}
              page={page}
              setPage={setPage}
              linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
              isExpert={false}
              requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
              loaders={props.loaders}
              requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
              requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
              requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
              contractorFeesSagis={[]}
              isConsultation={false}
              requestUpdateFirmReferenceManager={
                props.requestUpdateFirmReferenceManager
              }
            />
          )}
        {!isEmpty(props.claimRecap) && !isEmpty(props.policyInfo) && (
          <Container>
            <ClaimDeclaration
              isRecapPage
              isManager
              isReadOnly={false}
              inputProps={{ disableUnderline: true }}
              disableInput
              inputLabelProps
              listings={props.listings}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              policyInfo={props.policyInfo}
              setClaimRecap={props.setClaimRecap}
              isOpeningManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISOPENINGMANAGER,
              )}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              requestClaimRecap={props.requestClaimRecap}
            />
            <ClaimInformation
              isRecapPage
              isManager
              isReadOnly={false}
              inputProps={{ disableUnderline: true }}
              disableInput
              inputLabelProps
              listings={props.listings}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              policyInfo={props.policyInfo}
              setClaimRecap={props.setClaimRecap}
              stakeholders={[]}
              isOpeningManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISOPENINGMANAGER,
              )}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              requestSearchClaims={props.requestSearchClaims}
              foundClaims={props.foundClaims}
              requestClaimRecap={props.requestClaimRecap}
            />
            {featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
              <OpposingPartyRecapContainer
                isManager
                claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
                storedClaimToPreopen={props.claimRecap}
                listings={props.listings}
                policyInfo={props.policyInfo}
                setClaimRecap={props.setClaimRecap}
                requestCreateVehicle={props.requestCreateVehicle}
                requestValidateVehicle={props.requestValidateVehicle}
                requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
                setDataClaimToUpdate={props.setDataClaimToUpdate}
                dataClaimToUpdate={props.dataClaimToUpdate}
                sagisOpposingParties={extractOpposingParties(
                  get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
                )}
                requestClaimRecap={props.requestClaimRecap}
                claimId={props.match.params.claimId as any}
              />
            )}
            {get(props.claimRecap, 'claim.status') !==
            CLAIM_STATUS.VALIDATED ? (
              <ClaimCircumstances
                isRecapPage
                isManager
                isReadOnly={false}
                inputProps={{ disableUnderline: true }}
                disableInput
                inputLabelProps
                listings={props.listings}
                claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
                storedClaimToPreopen={props.claimRecap}
                setClaimRecap={props.setClaimRecap}
                claimCircumstancesSagis={get(
                  resolveSagisClaim(props.policyInfo),
                  'offeredRisks',
                  [],
                )?.find(
                  (element: { riskName: string }) =>
                    element.riskName === rcCoporeal,
                )}
                setIsSearchExecuted={setIsSearchExecuted}
                isSearchExecuted={isSearchExecuted}
              />
            ) : (
              <LawyerClaimCircumstances
                isRecapPage
                isReadOnly
                inputProps={{ disableUnderline: true }}
                inputLabelProps
                listings={props.listings}
                claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
                storedClaimToPreopen={props.claimRecap}
                setClaimRecap={props.setClaimRecap}
                setDataClaimToUpdate={props.setDataClaimToUpdate}
                dataClaimToUpdate={props.dataClaimToUpdate}
                isOpeningManager={userPrivileges.userHasPrivilege(
                  PRIVILEGES.ISOPENINGMANAGER,
                )}
              />
            )}
            <VictimCard
              isRecapPage
              isManager
              isReadOnly={false}
              disableInput
              listings={props.listings}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              setClaimRecap={props.setClaimRecap}
              isOpeningManager={isOpeningManager()}
              policyInfo={props.policyInfo}
              requestUpdateVictimInfo={props.requestUpdateVictimInfo}
              requestValidateVictim={props.requestValidateVictim}
              requestCreateVictim={props.requestAddVictims}
              updateFilde={() => null}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              requestClaimRecap={props.requestClaimRecap}
            />
            <UploadDocumentsBloc
              storedClaimToPreopen={props.claimRecap}
              isManager
              isRecap
              isReadOnly={false}
              index={0}
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              setDocumentId={props.setDocumentId}
              docId={props.documentId}
              pvDocument={updatedPVDocument}
              setPVDocument={setPVDocument}
              deletePVDocument={deletePVDocument}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              setDocument={setDocument}
              requestGetReportsPolicy={props.requestGetReportsPolicy}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
            {featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
              <FraudeInformation
                isRecapPage
                updateFilde={props.setDataClaimToUpdate}
                storedClaimToPreopen={props.claimRecap}
                claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
                setDataClaimToUpdate={props.setDataClaimToUpdate}
                dataClaimToUpdate={props.dataClaimToUpdate}
                listings={props.listings}
                setClaimRecap={props.setClaimRecap}
                claimRecap={props.claimRecap}
              />
            )}
            {featureService.hasFeature(
              FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
            ) &&
              userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
              get(props.claimRecap, 'claim.status') ===
                PROCEDURE_STATUSES.VALIDATED && (
                <PrimaryButton
                  background={BUTTON_COLORS.PRIMARY_BLUE}
                  border={BUTTON_COLORS.PRIMARY_BLUE}
                  titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                  title={translate(messages.validationButtonTitle, props)}
                  onClick={handleClickUpdateClaim}
                  className="validationButton"
                />
              )}
          </Container>
        )}
        <ProvisionIntervenantDialog
          open={isProvisionIntervenantDialogOpen}
          onClose={setIsProvisionIntervenantDialogOpen}
          intervenants={provisionIntervenants}
          listings={props.listings}
          requestValidateProvisionIntervenant={
            props.requestValidateProvisionIntervenant
          }
          riskId={riskId}
          claimId={props.claimId}
        />
      </GlobalBloc>
    </>
  );
};

export default PendingOrRejectedRecapClaim;
